import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ListQueryParameters, PagingResults } from '../../types/utils';
import { AdminLogNavigation, AdminLogObject, AdminLogSearch } from '../../types/adminLog';

export class AdminLogApi extends JBaseApi {
    public getLogsNavigation(params: ListQueryParameters, signal?: AbortSignal) {
        return this.network.post<PagingResults<AdminLogNavigation>>(
            {
                o: 'objectList',
                f: 'adminAdvancedLogsNavigation',
                ...params,
            } as OF,
            signal,
        );
    }

    public getLogsObjects(params: ListQueryParameters, signal?: AbortSignal) {
        return this.network.post<PagingResults<AdminLogObject>>(
            {
                o: 'objectList',
                f: 'adminAdvancedLogsObjects',
                ...params,
            } as OF,
            signal,
        );
    }

    public getLogsSearch(params: ListQueryParameters, signal?: AbortSignal) {
        return this.network.post<PagingResults<AdminLogSearch>>(
            {
                o: 'objectList',
                f: 'adminAdvancedLogsSearch',
                ...params,
            } as OF,
            signal,
        );
    }
}
